import type { MultiSelectOption } from '@rtkwlf/fenrir-react';
import type { QueryParamConfig } from 'use-query-params';

export const LabelLookupMultiSelectOptionParam = (
  labelLookupsByValue: Record<string, string> = {},
): QueryParamConfig<MultiSelectOption[] | undefined> => {
  return {
    encode: (options) => {
      if (!options) {
        return null;
      }

      return options.map(({ value }) => `${value}`).join(',');
    },

    decode: (values) => {
      const hasNoValueSelected = values === '';
      if (hasNoValueSelected) {
        return [];
      }

      const hasDefaultValueSelected = !values;
      if (hasDefaultValueSelected) {
        return undefined;
      }

      const multiValuesParams = Array.isArray(values) ? values : [values];

      const options: MultiSelectOption[] = multiValuesParams
        .filter<string>((valueParam): valueParam is string => !!valueParam)
        .flatMap((valueParam) =>
          valueParam.split(',').map((valueParam) => ({
            label: labelLookupsByValue[valueParam] ?? valueParam,
            value: valueParam,
          })),
        );

      return options;
    },
  };
};
